import { Navigate, Outlet, useLocation } from "react-router-dom";

const GuestRoutes = () => {
  const token = localStorage.getItem("ProviderToken");
  const setup = window.localStorage.getItem("ProviderSetup");
  const setupCompleted = setup === "true";
  const location = useLocation();

  // Allow access to homepage (index page) regardless of token status
  if (location.pathname === "/" || location.pathname === "") {
    return <Outlet />;
  }

  // For auth pages (login, register, etc.), check token and redirect if authenticated
  if (location.pathname.startsWith("/auth")) {
    if (token) {
      // If token exists, user is authenticated - redirect based on setup status
      // If setup is not completed, redirect to business-setup
      if (!setupCompleted) {
        return <Navigate to={"/business-setup"} replace />;
      }
      // If setup is completed, redirect to dashboard
      return <Navigate to={"/dashboard"} replace />;
    }
    // If no token, allow access to auth pages
    return <Outlet />;
  }

  // For all other routes, allow access
  return <Outlet />;
};

export default GuestRoutes;
